import React from "react";

import * as Styles from "./styles";

export function BestOfferModal({ children, title, description, onCancel, onConfirm }) {
  return (
    <Styles.Root>
      <Styles.Trigger asChild>{children}</Styles.Trigger>
      <Styles.Portal>
        <Styles.Overlay />
        <Styles.Content>
          <Styles.Title>Melhor oferta</Styles.Title>
          <Styles.Description>
            {title ? <strong>{title}</strong> : null}
            <span>{description}</span>
          </Styles.Description>
          <Styles.ButtonsContainer>
            <Styles.Button onClick={onConfirm}>Eu quero!</Styles.Button>
            <Styles.Button onClick={onCancel} variant="secondary">Não, obrigado(a)</Styles.Button>
          </Styles.ButtonsContainer>
        </Styles.Content>
      </Styles.Portal>
    </Styles.Root>
  );
}
